export class RecordRestoreResult {
    'outputLocations';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "outputLocations",
            "baseName": "outputLocations",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RecordRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
